import shaderSource from '../shaders/fullscreen.wgsl?raw';

export interface FullscreenPipeline {
  pipeline: GPURenderPipeline;
  bindGroup: GPUBindGroup;
}

export function createFullscreenPipeline(
  device: GPUDevice,
  format: GPUTextureFormat,
  bindGroupLayout: GPUBindGroupLayout,
  uniformBuffer: GPUBuffer,
): FullscreenPipeline {
  const shaderModule = device.createShaderModule({ code: shaderSource });

  const pipelineLayout = device.createPipelineLayout({
    bindGroupLayouts: [bindGroupLayout],
  });

  const pipeline = device.createRenderPipeline({
    layout: pipelineLayout,
    vertex: {
      module: shaderModule,
      entryPoint: 'vs',
    },
    fragment: {
      module: shaderModule,
      entryPoint: 'fs',
      targets: [{ format }],
    },
    primitive: {
      topology: 'triangle-list',
    },
  });

  const bindGroup = device.createBindGroup({
    layout: bindGroupLayout,
    entries: [
      { binding: 0, resource: { buffer: uniformBuffer } },
    ],
  });

  return { pipeline, bindGroup };
}
